import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import NoData from '../NoData/NoData';
import Item from './Item';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { connect } from 'react-redux';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};


function getItems(isRestaurant, vendor, vendorId, items, closed, productLoading) {
    var itemsArray = []
    if (items?.length) {
        items.map(item =>
            itemsArray.push(<Grid item xs={6} xl={2} lg={2} md={2} sm={6}><Item viewMore={true} vendor={vendor} closed={closed} id={item.id} vendorId={vendorId} image={item?.image} isMenu={isRestaurant} price={item?.price} description={item?.description} title={item?.name} product={item} /></Grid>)
        )
    } else {
        itemsArray.push(<div>{productLoading ? 'Loading products...' : 'No Record Found'}</div>)
    }
    return itemsArray
}

const Items = ({ index, categoryId, subCategoryId, isRestaurant, vendorId, allProducts, allMenus, closed, productLoading, isOffer, vendor }) => {
    const [items, updateItems] = useState([]);
    const [agent, setAgent] = useState('')
    const [activeItemIndex, setActiveItemIndex] = useState(0);
    const chevronWidth = 40;
    useEffect(() => {
        if (!isRestaurant) {
            // const tempItems = allProducts?.filter((item) => {
            //     return item.subCategoryId === subCategoryId;
            // });
            // updateItems(tempItems);
        } else {
            const tempItems = allMenus?.filter((item) => {
                return item.subCategoryId === subCategoryId;
            });
            updateItems(tempItems);
        }
        if (/Mobi/.test(navigator.userAgent)) {
            setAgent('mobile')
        }

    }, [])
    var tempItems = []
    if (isOffer) {
        tempItems = allProducts?.filter((item) => {
            return item.isOffer && item.categoryId === subCategoryId;
        });
    } else {
        tempItems = allProducts?.filter((item) => {
            return item.subCategoryId === subCategoryId;
        });
    }


    return (
        <div>
            <Grid container>
                {getItems(isRestaurant, vendor, vendorId, tempItems, closed, productLoading)}
            </Grid>
        </div>
    );
};

const mapStateToProps = (state) => ({
    productLoading: state.user.productLoading
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Items);